import tr from './tr.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export type Locale = 'tr' | 'en';

export type MessageKey = keyof typeof tr;

const MESSAGES: Record<Locale, Record<string, string>> = {
  tr,
  en,
};

const DEFAULT_LOCALE: Locale = 'tr';

function detectBrowserLocale(): Locale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const lang = (navigator.language ?? '').toLowerCase();
  if (lang.startsWith('en')) return 'en';
  return DEFAULT_LOCALE;
}

export interface Translator {
  (key: MessageKey, vars?: Record<string, string | number>): string;
  readonly locale: Locale;
}

export function makeTranslator(locale: Locale = detectBrowserLocale()): Translator {
  const table = MESSAGES[locale] ?? MESSAGES[DEFAULT_LOCALE];
  const fn = (key: string, vars?: Record<string, string | number>): string => {
    let value = table[key] ?? MESSAGES[DEFAULT_LOCALE][key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
      }
    }
    return value;
  };
  return Object.assign(fn as Translator, { locale });
}

export function listLocales(): readonly Locale[] {
  return Object.keys(MESSAGES) as Locale[];
}
